
/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
/// <reference path="../../_ext/editors/grideditorbase.ts" />

namespace TabAurous.Inventory {

    import fld = SortingItemsRow.Fields;
    @Serenity.Decorators.registerClass()
    export class SortingItemsEditor extends Common.GridEditorBase<SortingItemsRow> {


        protected getColumnsKey() { return "Inventory.SortingItems"; }
        protected getDialogType() { return SortingItemsDialog; }
        protected getLocalTextPrefix() { return SortingItemsRow.localTextPrefix; }
        protected form: SortingItemsForm;

        private pendingChanges: Q.Dictionary<any> = {};

        // #region Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;
        public ExchangeRate: number;
        public DeptId: number;
        private NewLineNo: number;
        private GenSKU = true;
        private contractTotals: string;
        public TotalItems: number;
        statement: string;

        // #endregion


        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: false });
        }



        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            var str = ctx => ColumnFormatter.stringInputFormatter(ctx, this);


            //Q.first(columns, x => x.field === fld.Weight).format = num;

            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        // #endregion

        public getTotalRows() {
            this.TotalItems = this.view.getItems().length;
            return this.TotalItems;
        }
        //#region  ItemGrid Inline Editor
        // **** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm('Are you sure want to delete? ', () => {

                        var id = this.id(item);
                        this.TotalItems = this.view.getItems().length - 1;
                        this.view.deleteItem(id);

                    });
                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }


        //#region Inline Editor
        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;

            // *** Validate Decimal & Integer***
            if (field === fld.Weight) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else if (input.hasClass('numeric')) {
                var i = Q.parseInteger(text);
                if (isNaN(i) || i > 32767 || i < 0) {
                    Q.notifyError(Q.text('Validation.Integer'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
                value = i;
            }
            else {
                value = text;
            }

            // *** Update Weight, Amount etc on Pieces Change***

            if (field === fld.Weight) {
                if (item.CalcOnId != 3 && item.HasBom == false) {
                    var Net = (item.UnitRate) * value;
                    item.GrossAmount = Net;
                    item.NetWeight = value;

                    item[field] = value;
                }
                else {
                    item[field] = value;
                }

            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            this.view.updateItem(id, item);
            this.view.refresh();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        // #endregion

        //Set Data for New SKU Generated
        public setData(entity: SortingDetailsRow, AtbId: number, pieces: number, weight: number, productid: number, lotno: string) {
            var x = entity;
            var LotNo = lotno == "" ? FormatHelper.GetFormats("Lot") : lotno;
            var netwtperitem = entity.NetWeight / entity.Pieces;

            //var stockitem = Stock.StockItemRow.getLookup().itemById[entity.StockId];

            let prddetails;
            OMS.ProductMasterService.Retrieve({
                EntityId: productid
            }, response => {
                prddetails = response.Entity
            }, { async: false });
            var item: SortingItemsRow = {
                ProductId: productid,
                ProductCode: prddetails.ProductCode,
                ProductName: prddetails.ProductName,
                AttributeId: AtbId,
                CalcOnId: x.CalcOnId,
                CompanyId: x.CompanyId,
                DepartmentId: x.DepartmentId,
                SKU: "",
                LotNo: LotNo,

                Pieces: pieces,
                Weight: weight,
                NetWeight: netwtperitem,
                Line_No: x.Line_No,
                ItemTypeId: x.ItemTypeId,
                ProductTypeId: x.ProductTypeId,
                CategoryId: x.CategoryId,
                SubCategoryId: x.SubCategoryId,
                BagNo: x.BagNo,
                CertificateNo: x.CertificateNo,
                Hsn: x.Hsn,
                RefTransId: entity.RefTransId,
                RefTransItemId: entity.RefTransItemId,
                RefVoucherId: entity.RefVoucherId,
                UnitRate: entity.UnitRate,
                GrossAmount: x.CalcOnId == 3 ? pieces * entity.UnitRate : weight * entity.UnitRate,
                HasBom: x.HasBom,
                Lab: x.Lab,
                StoneSizeId: x.StoneSizeId,
                StoneSizeName: x.StoneSizeName,
                SieveId: x.SieveId,
                SieveName: x.SieveName,
                StoneColorId: x.StoneColorId,
                StoneColoreName: x.StoneColoreName,
                QualityId: x.QualityId,
                QualityName: x.QualityName,
                ShapeId: x.ShapeId,
                ShapeName: x.ShapeName,
                StockAllocation: false,
                

            }
            item[this.getIdProperty()] = "`" + this.nextId++;
            this.view.addItem(item);

        }

        public setOldItems(entity: any[]) {
            this.view.setItems([]);
            for (var i = 0; i < entity.length; i++) {
                entity[i][this.getIdProperty()] = "`" + this.nextId++;
                this.view.addItem(entity[i]);
            }
        }
        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");

            return buttons;
        }



        // #endregion




    }
}